export const DAY_WIDTH = 70;
export const FIRST_COLUMN_GAP = 1.5;
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
